import {Injectable, Injector} from '@angular/core';
import {HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {LoginDialogService} from 'app/shared/service/login-dialog.service';
import {AuthenticationService} from '@enerbim/commons-lib';

/**
 * Intercepteur pour les erreurs 401 unauthorized.
 * Lorsqu'une telle erreur se produit, on va déconnecter l'utilisateur, puis rouvrir la popup de login.
 * Après la fermeture de la popup de login, on fera un refresh pour exécuter à nouveau les requêtes échouées en 401.
 */
@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
    constructor(
        private injector: Injector,
        private authenticationService: AuthenticationService,
        private loginModalService: LoginDialogService,
    ) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401 && !request.url.endsWith('/account') && !request.url.endsWith('/authenticate')) {
                    return this.authenticationService.logout().pipe(
                        tap(() => this.loginModalService.open({callback: () => location.reload()}))
                    );
                } else {
                    return throwError(err);
                }
            })
        );
    }
}
